module.exports = __webpack_public_path__ + "static/media/JP_VS_EYELASHES03.313346e5.jpg";